import React from 'react';
import { ThemeProvider } from './context/ThemeContext.tsx';
import { AuthProvider, useAuth } from './context/AuthContext.tsx';
import { RealtimeProvider } from './context/RealtimeContext.tsx';
import { NotificationProvider } from './context/NotificationContext.tsx';
import { AppLayout } from './components/layout/AppLayout.tsx';
import { LoginView } from './components/auth/LoginView.tsx';

import { TenantProvider } from './context/TenantContext.tsx';
import { CallProvider } from './context/CallContext.tsx';
import { OnboardingProvider } from './context/OnboardingContext.tsx';
import { UserProfileModalProvider } from './context/UserProfileModalContext.tsx';
import { ChatUnreadProvider } from './context/ChatUnreadContext.tsx';
import { PermissionsProvider } from './context/PermissionsContext.tsx';

const AppContent: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen w-screen flex flex-col items-center justify-center bg-surface-50 dark:bg-surface-950">
        <div className="w-10 h-10 border-4 border-brand-500/20 border-t-brand-500 rounded-full animate-spin mb-4" />
        <span className="text-xs font-semibold text-surface-500 uppercase tracking-wider">
          Initializing Pulse...
        </span>
      </div>
    );
  }

  if (!user) {
    return <LoginView />;
  }

  return <AppLayout />;
};

export const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RealtimeProvider>
          <TenantProvider>
            <CallProvider>
              <NotificationProvider>
                <OnboardingProvider>
                  <UserProfileModalProvider>
                    <PermissionsProvider>
                      <ChatUnreadProvider>
                        <AppContent />
                      </ChatUnreadProvider>
                    </PermissionsProvider>
                  </UserProfileModalProvider>
                </OnboardingProvider>
              </NotificationProvider>
            </CallProvider>
          </TenantProvider>
        </RealtimeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
